module.exports = __webpack_public_path__ + "img/Stemness-GBM_10X_TPCP.3982355f.png";